import React from 'react';
import config from '../../../../../config';
import { ObjectiveAnswer } from '../../../types';
import { ASCII_LOWERCASE_A, IDK_ANSWER_ID } from './constants';

export const getOptionLabel = (index: number): string => {
  return String.fromCharCode(ASCII_LOWERCASE_A + index);
};

export const buildImgSrc = (img?: string | null): string | null => {
  if (!img) return null;

  const domain = config.s3Url;
  const path = 'uploads/';
  const imgWithPath = img.indexOf(path) >= 0 ? img : path + img;

  return `${domain}${imgWithPath}`;
};

export const renderImg = (img?: string | null): JSX.Element | null => {
  const src = buildImgSrc(img);

  if (!src) return null;

  return <img src={src} alt="" style={{ marginTop: 10 }} />;
};

export const findCorrectAnswer = (answers: ObjectiveAnswer[]): number | undefined => {
  const correctFromAnswereds = answers.find(
    (answer) => answer.answereds?.some((a) => a.is_correct)
  );
  if (correctFromAnswereds) {
    return correctFromAnswereds.id_resposta;
  }

  return answers.find((answer) => answer.correta === 1)?.id_resposta;
};

export const findUserMarkedAnswer = (answers: ObjectiveAnswer[]): number | undefined => {
  const markedAnswer = answers.find(
    (answer) => answer.answereds?.some((a) => a.is_marked)
  );
  return markedAnswer?.id_resposta;
};

export const wasIdkMarked = (reviewAnswerId: number | undefined): boolean => {
  return reviewAnswerId === IDK_ANSWER_ID;
};

export interface AnswerStatus {
  isAnswerCorrect: boolean;
  isUserAnswer: boolean;
  isChecked: boolean;
  userGotItRight: boolean;
  showAsCorrect: boolean;
  showAsWrong: boolean;
  showCorrectAnswer: boolean;
}

export const getAnswerStatus = (
  answerId: number,
  questionAnswer: number | undefined,
  questionAnswerCorrect: number | undefined
): AnswerStatus => {
  const isIdkAnswer = answerId === IDK_ANSWER_ID;
  const isAnswerCorrect = answerId === questionAnswerCorrect;
  const isUserAnswer = answerId === questionAnswer;
  const isChecked = questionAnswerCorrect !== undefined;
  const userGotItRight = !isIdkAnswer && questionAnswer === questionAnswerCorrect;
  const showAsCorrect = isChecked && userGotItRight && isUserAnswer;
  const showAsWrong = isChecked && !userGotItRight && isUserAnswer;
  const showCorrectAnswer = isChecked && !userGotItRight && isAnswerCorrect;

  return {
    isAnswerCorrect,
    isUserAnswer,
    isChecked,
    userGotItRight,
    showAsCorrect,
    showAsWrong,
    showCorrectAnswer,
  };
};

export const isIdkAnswer = (answerId: number | undefined): boolean => {
  return answerId === IDK_ANSWER_ID;
};
